var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.417l2.458 2.458c.549.56 1.3.875 2.084.875s1.534-.315 2.083-.875h0c.56-.549.875-1.3.875-2.083 0-.784-.315-1.535-.875-2.084l-1.625-1.625M7.854 8.104L5 5.25M3.25 5.833L5 5.25 5.583 3.5 3.25 1.167.917 3.5zM18.482 3.685l-2.565 2.554-2.996-2.98L15.488.704C14.895.447 14.244.36 13.605.448c-2.461.212-4.334 2.3-4.277 4.77-.007.467.08.932.255 1.365L1.371 13.82c-.576.513-.918 1.238-.95 2.008-.033.77.248 1.52.779 2.08h0c.543.568 1.305.876 2.091.844.786-.032 1.52-.4 2.016-1.011l7.271-8.175c.778.228 1.595.285 2.396.167 1.72-.356 3.104-1.634 3.593-3.322.272-.893.243-1.85-.085-2.725z",
    transform: "translate(.417 .417)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceGrey);
export default __webpack_public_path__ + "static/media/maintenance-grey.511b9e3b4301acdfb31ff9a9465f6a8e.svg";
export { ForwardRef as ReactComponent };